import { jsx as _jsx } from "react/jsx-runtime";
import useAuthWidget from '@/hooks/use-auth-widget';
var AuthSection = function () {
    useAuthWidget();
    return _jsx("div", { id: 'vjw-auth-section' });
};
export default AuthSection;
